var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApKitchenSuppressionSystemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9 -9.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.117,10.58H11.88a2.786,2.786,0,1,0,0,5.57h3.23v.894a3.354,3.354,0,0,0,2.984,3.288V24.17a8.6,8.6,0,0,0,4.961,7.709V33.12H20.99a2.86,2.86,0,0,0-2.9,2.817v1.636a.484.484,0,0,0,.491.477h16.83a.484.484,0,0,0,.491-.477V35.937a2.86,2.86,0,0,0-2.9-2.817H30.945V31.879a8.6,8.6,0,0,0,4.961-7.709V20.332a3.352,3.352,0,0,0,2.984-3.288V16.15h3.23a2.786,2.786,0,1,0,0-5.57Zm0,4.618H11.88a1.831,1.831,0,1,1,0-3.66H42.117a1.831,1.831,0,1,1,0,3.66Zm-4.212,1.849a2.4,2.4,0,0,1-2.428,2.362H18.519a2.4,2.4,0,0,1-2.428-2.362v-.894H37.905v.894ZM34.921,24.17A7.622,7.622,0,0,1,30.942,30.8a15.118,15.118,0,0,0-.065-2.479,5.484,5.484,0,0,0,1.914-4.157V20.36h2.13v3.807Zm0,11.766V37.1H19.073V35.937a1.889,1.889,0,0,1,1.914-1.862H33.01a1.891,1.891,0,0,1,1.914,1.862Zm-9.8-15.576v5.767a3.041,3.041,0,0,0-1.607,1.244,4.529,4.529,0,0,1-1.332-3.2V20.364h2.939Zm.982,5.6v-5.6h1.78c0,5.592.016,5.6-.016,5.6H26.1ZM24.138,28.3a2.079,2.079,0,0,1,1.98-1.384,12.761,12.761,0,0,1,2.16.041,2.04,2.04,0,0,1,1.679,1.973v4.182h-5.93c0-4.379-.046-4.37.108-4.812Zm7.667-4.134a4.524,4.524,0,0,1-1.335,3.2,3.041,3.041,0,0,0-1.607-1.244V20.364H31.8V24.17ZM19.069,20.364H21.2V24.17a5.489,5.489,0,0,0,1.914,4.157,13.244,13.244,0,0,0-.065,2.479,7.626,7.626,0,0,1-3.979-6.633V20.367Z",
    transform: "translate(0 0)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4,108.484l-.416-2.095a.524.524,0,0,0-1.028.2l.416,2.1A.524.524,0,0,0,95.4,108.484Z",
    transform: "translate(-57.223 -64.744)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.549,108.989v-2.095a.525.525,0,0,0-1.049,0v2.095A.525.525,0,0,0,73.549,108.989Z",
    transform: "translate(-42.76 -65.008)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.549,108.989v-2.095a.525.525,0,0,0-1.049,0v2.095A.525.525,0,0,0,53.549,108.989Z",
    transform: "translate(-29.292 -65.008)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9,108.695l.416-2.1a.524.524,0,0,0-1.028-.2l-.416,2.095a.524.524,0,0,0,1.028.2Z",
    transform: "translate(-14.049 -64.748)",
    stroke: "#000",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApKitchenSuppressionSystemIcon);
export default __webpack_public_path__ + "static/media/ap-kitchen-suppression-system-icon.8bd4b29e21f9be5e910fec723c4f81ce.svg";
export { ForwardRef as ReactComponent };